module.exports = __webpack_public_path__ + "img/circle-silver-blank-small.beaf2ba5.png";